import NumerousLogo from "@/components/logo/NumerousLogo";
import { TypographyBase } from "@/components/typography/Base";
import { TypographyH3 } from "@/components/typography/H3";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/account-deleted")({
  component: AccountDeleted
});

function AccountDeleted() {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center dark:bg-brand-gray-950 gap-y-2">
      <NumerousLogo type="fullLogo" size="sm" className="mb-5" />
      <TypographyH3>Your account has been deleted</TypographyH3>
      <TypographyBase>
        Your Numerous account has been deleted. You can now close this window.
      </TypographyBase>
    </div>
  );
}
